export default __webpack_public_path__ + "static/media/about1_2.eda68d97.png";